/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PuttingSplitsTableQueryVariables = {|
  eventId: string,
  grassCategoryIds: $ReadOnlyArray<?string>,
|};
export type PuttingSplitsTableQueryResponse = {|
  +whoAmI: ?{|
    +username: string
  |},
  +pgaPuttingSplitsOverview: ?$ReadOnlyArray<?{|
    +player: ?{|
      +id: string,
      +fullName: ?string,
      +dkPlayer: ?{|
        +id: string,
        +playerDkId: number,
      |},
    |},
    +numRounds: ?number,
    +strokesGainedPutting: ?any,
    +putt0612FtPct: ?any,
    +putt1218FtPct: ?any,
    +puttsPerHole: ?any,
  |}>,
|};
export type PuttingSplitsTableQuery = {|
  variables: PuttingSplitsTableQueryVariables,
  response: PuttingSplitsTableQueryResponse,
|};
*/


/*
query PuttingSplitsTableQuery(
  $eventId: ID!
  $grassCategoryIds: [ID]!
) {
  whoAmI {
    username
    id
  }
  pgaPuttingSplitsOverview(eventId: $eventId, grassCategories: $grassCategoryIds) {
    player {
      id
      fullName
      dkPlayer {
        id
        playerDkId
      }
    }
    numRounds
    strokesGainedPutting
    putt0612FtPct
    putt1218FtPct
    puttsPerHole
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "grassCategoryIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "eventId",
      "variableName": "eventId"
    },
    {
      "kind": "Variable",
      "name": "grassCategories",
      "variableName": "grassCategoryIds"
    }
  ],
  "concreteType": "PGATourPuttingSplitsOverviewRowType",
  "kind": "LinkedField",
  "name": "pgaPuttingSplitsOverview",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PGATourPlayerType",
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlayerType",
          "kind": "LinkedField",
          "name": "dkPlayer",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "playerDkId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numRounds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "strokesGainedPutting",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "putt0612FtPct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "putt1218FtPct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "puttsPerHole",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PuttingSplitsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PuttingSplitsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "b319f4634e2ab8a412584ade76f50f38",
    "id": null,
    "metadata": {},
    "name": "PuttingSplitsTableQuery",
    "operationKind": "query",
    "text": "query PuttingSplitsTableQuery(\n  $eventId: ID!\n  $grassCategoryIds: [ID]!\n) {\n  whoAmI {\n    username\n    id\n  }\n  pgaPuttingSplitsOverview(eventId: $eventId, grassCategories: $grassCategoryIds) {\n    player {\n      id\n      fullName\n      dkPlayer {\n        id\n        playerDkId\n      }\n    }\n    numRounds\n    strokesGainedPutting\n    putt0612FtPct\n    putt1218FtPct\n    puttsPerHole\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c80d30f8d653df87a3e2790e45674df';

module.exports = node;
